import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { MsalProvider } from "@azure/msal-react";
import { Configuration,  PublicClientApplication } from "@azure/msal-browser";

// MSAL configuration// 
const configuration: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENTID || "",
    authority: process.env.REACT_APP_AZURE_AUTHORITY || ""
  }
};

const pca = new PublicClientApplication(configuration);

// Component
const AppProvider = () => (
  <MsalProvider instance={pca}>
      <App />
  </MsalProvider>
);

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<AppProvider />);


